/* eslint-disable react/jsx-max-depth */
import { Button, Card, Col, Row } from "react-bootstrap";
import { Link, Route, Routes, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";

import AccountInfoForm from "./registration/AccountInfoForm";
import ProfileInfoForm from "./registration/ProfileInfoForm";
import ProfileInfoSidebar from "./registration/ProfileInfoSidebar";
import loginImage from "../../assets/images/login-image.webp";
import { useCallback } from "react";

const Register = () => {
	const navigate = useNavigate();

	const handleSuccess = useCallback(() => {
		navigate("/account/register-success");
	}, []);

	return (
		<>
			<Helmet>
				<title>
					Life With Cancer - Sign Up
				</title>
			</Helmet>

			<Card className="my-4">
				<Row className="gx-0">
					<Col lg={8} xs={12}>
						<div className="p-3 p-lg-5">
							<h1 className="mb-1 text-neutral6">
								Sign up for a
							</h1>

							<h2 className="text-blue">
								Life with Cancer Account
							</h2>

							<Routes>
								<Route element={<ProfileInfoForm onSuccess={handleSuccess} submitText="Complete Registration" />} path="profile" />
								<Route element={<AccountInfoForm />} path="" />
							</Routes>

						</div>

						<div className="bg-bluetype5 gx-0 p-5 align-items-center d-flex">
							<div className="flex-fill">
								<p className="mb-1 text-neutral3 text-uppercase fw-bold">
									Already have an account?
								</p>
							</div>
							<div className="flex-fill text-end">
								<Button as={Link} to="/login" variant="lightblue">
									Log In
								</Button>
							</div>
						</div>
					</Col>

					<Col
						className="bg-blue text-white"
						lg={4} md={6}
						sm={12}
						style={{
							backgroundImage: `url(${loginImage})`,
							backgroundPosition: "center center",
							backgroundSize: "cover"
						}}
					>
						<div className="overlay bg-darkblue p-5 h-100 w-100 bg-opacity-75">
							<ProfileInfoSidebar />
						</div>
					</Col>
				</Row>
			</Card>
		</>
	);
};

export default Register;
